require('script-loader!file-saver');
require('script-loader!@/views/components/excel/Blob');
import XLSX from 'xlsx'

export function EXout(tmpWB,type){

  var wopts = {
    bookType: 'xlsx',
    bookSST: true,
    type: 'binary',
    cellStyles: true
  };

  function getCharCol(n) {
      let temCol = '',
        s = '',
        m = 0
      while(n > 0) {
        m = n % 26 + 1
        s = String.fromCharCode(m + 64) + s
        n = (n - m) / 26
      }
      return s
  }

  function s2ab(s) {
      if(typeof ArrayBuffer !== 'undefined') {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for(var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      } else {
        var buf = new Array(s.length);
        for(var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      }
  }

  /*var elt = tbdom;
  var tmpWB = XLSX.table_to_book(elt, {sheet:"Sheet"});
  for(var key in tmpWB.Sheets.Sheet){
      if(key != "!merges" && key != "!ref"){
        tmpWB.Sheets.Sheet[key].s = {
            alignment: {
              vertical: "center",
              horizontal: "center"
            }
        }
      }
  }*/

  var tmpDown = new Blob([s2ab(XLSX.write(tmpWB, {
      bookType: (type == undefined ? 'xlsx' : type),
      bookSST: false,
      type: 'binary'
    } //这里的数据是用来定义导出的格式类型
  ))], {
    type: ""
  });

  saveAs(tmpDown, 'tabs' + '.' + (wopts.bookType == "biff2" ? "xls" : wopts.bookType));
}



// WEBPACK FOOTER //
// ./src/utils/excel.js